import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            redirect: "/dashboard",
            component: () => import("@/view/layout/Layout"),
            children: [
                // Home pages
                {
                    path: "/dashboard",
                    name: "dashboard",
                    component: () => import("@/view/pages/Custom/Dashboard.vue"),
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: "/subscribe",
                    name: "subscribe",
                    component: () => import("@/view/pages/Custom/Subscribe.vue"),
                    meta: { requiresAuth: true },
                },
                {
                    path: "/error-payment",
                    meta: { requiresAuth: true },
                    redirect: {
                        name: "dashboard",
                        params: {
                            propFlashMessages: "payment_failed",
                        },
                    },
                },
                {
                    path: "/payment-paypal",
                    meta: { requiresAuth: true },
                    name: "payment-paypal",
                    component: () => import("@/view/pages/Custom/Payments/ExecutePaypal.vue"),
                },
                {
                    path: "/payment-stripe",
                    meta: { requiresAuth: true },
                    name: "payment-stripe",
                    component: () => import("@/view/pages/Custom/Payments/ExecuteStripe.vue"),
                },
                {
                    path: "/profile",
                    name: "profile",
                    component: () => import("@/view/pages/Custom/Profile.vue"),
                    meta: { requiresAuth: true },
                },

                // Search Hashtags
                {
                    path: "/search",
                    name: "search",
                    component: () => import("@/view/pages/Custom/Search/Search.vue"),
                    meta: { requiresAuth: true, requiresPremium: true },
                },
                {
                    path: "/lite",
                    name: "lite",
                    component: () => import("@/view/pages/Custom/Search/Lite.vue"),
                    meta: { requiresAuth: true },
                },
                {
                    path: "/bulk",
                    name: "bulk",
                    component: () => import("@/view/pages/Custom/Search/Bulk.vue"),
                    props: true,
                    meta: { requiresAuth: true, requiresPremium: true },
                },
                {
                    path: "/relevant",
                    name: "relevant",
                    component: () => import("@/view/pages/Custom/Search/Relevant.vue"),
                    meta: { requiresAuth: true, requiresPremium: true },
                },
                {
                    path: "/viralsearch",
                    name: "viralsearch",
                    component: () => import("@/view/pages/Custom/Search/ViralSearch.vue"),
                    meta: { requiresAuth: true, requiresPremium: true },
                },
                {
                    path: "/viralfinder",
                    name: "viralfinder",
                    component: () => import("@/view/pages/Custom/Search/ViralCategories.vue"),
                    meta: { requiresAuth: true, requiresPremium: true },
                },
                {
                    path: "/banned",
                    name: "banned",
                    component: () => import("@/view/pages/Custom/Search/BannedHashtags.vue"),
                    meta: { requiresAuth: true, requiresPremium: true },
                },

                // Manage Hashtags
                {
                    path: "/myhashtags",
                    name: "myhashtags",
                    component: () => import("@/view/pages/Custom/Manage/MyHashtags.vue"),
                    meta: { requiresAuth: true, requiresPremium: true },
                },
                {
                    path: "/shuffle",
                    name: "shuffle",
                    component: () => import("@/view/pages/Custom/Manage/HashtagShuffle.vue"),
                    meta: { requiresAuth: true, requiresPremium: true },
                },

                // Accounts
                {
                    path: "/accountdashboard",
                    name: "accountdashboard",
                    component: () => import("@/view/pages/Custom/Accounts/AccountDashboard.vue"),
                    props: true,
                    meta: { requiresAuth: true, requiresPremium: true },
                },
                {
                    path: "/mycampaigns",
                    name: "mycampaigns",
                    component: () => import("@/view/pages/Custom/Accounts/MyCampaigns.vue"),
                    props: true,
                    meta: { requiresAuth: true, requiresPremium: true },
                },
                {
                    path: "/accountscanner",
                    name: "accountscanner",
                    component: () => import("@/view/pages/Custom/Accounts/AccountScanner.vue"),
                    props: true,
                    meta: { requiresAuth: true, requiresPremium: true },
                },
                {
                    path: "/myaccounts",
                    name: "myaccounts",
                    component: () => import("@/view/pages/Custom/Accounts/MyAccounts.vue"),
                    meta: { requiresAuth: true, requiresPremium: true },
                },
                {
                    path: "/accountinsights",
                    name: "accountinsights",
                    component: () => import("@/view/pages/Custom/Accounts/AccountInsights.vue"),
                    props: true,
                    meta: { requiresAuth: true, requiresPremium: true },
                },
                {
                    path: "/facebookcallback",
                    name: "facebookcallback",
                    component: () => import("@/view/pages/Custom/Accounts/ExecuteFacebookAccountAdd.vue"),
                    meta: { requiresAuth: true, requiresPremium: true },
                },

                // OTHER pages
                {
                    path: "/faq",
                    name: "faq",
                    component: () => import("@/view/pages/Custom/Other/FAQ.vue"),
                    meta: { requiresAuth: true },
                },
                {
                    path: "/affiliates",
                    name: "affiliates",
                    component: () => import("@/view/pages/Custom/Other/Affiliates.vue"),
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: "/support",
                    name: "support",
                    component: () => import("@/view/pages/Custom/Other/Support.vue"),
                    meta: { requiresAuth: true },
                },

                // ADMIN pages
                {
                    path: "/admin",
                    name: "admin",
                    component: () => import("@/view/pages/Custom/Admin/Admin.vue"),
                    meta: { requiresAuth: true, requiresPremium: true },
                },
                {
                    path: "/admin-payments",
                    name: "admin-payments",
                    component: () => import("@/view/pages/Custom/Admin/Payments.vue"),
                    meta: { requiresAuth: true, requiresPremium: true },
                },
                {
                    path: "/admin-statistics",
                    name: "admin-statistics",
                    component: () => import("@/view/pages/Custom/Admin/Statistics.vue"),
                    meta: { requiresAuth: true, requiresPremium: true },
                },
                {
                    path: "/admin-engines",
                    name: "admin-engines",
                    component: () => import("@/view/pages/Custom/Admin/Engines.vue"),
                    meta: { requiresAuth: true, requiresPremium: true },
                },
                {
                    path: "/admin-tools",
                    name: "admin-tools",
                    component: () => import("@/view/pages/Custom/Admin/Tools.vue"),
                    meta: { requiresAuth: true, requiresPremium: true },
                },
            ],
        },
        {
            path: "/error",
            name: "error",
            component: () => import("@/view/pages/error/Error.vue"),
            children: [
                {
                    path: "error-1",
                    name: "error-1",
                    component: () => import("@/view/pages/error/Error-1.vue"),
                },
                {
                    path: "error-2",
                    name: "error-2",
                    component: () => import("@/view/pages/error/Error-2.vue"),
                },
                {
                    path: "error-3",
                    name: "error-3",
                    component: () => import("@/view/pages/error/Error-3.vue"),
                },
                {
                    path: "error-4",
                    name: "error-4",
                    component: () => import("@/view/pages/error/Error-4.vue"),
                },
                {
                    path: "error-5",
                    name: "error-5",
                    component: () => import("@/view/pages/error/Error-5.vue"),
                },
                {
                    path: "error-6",
                    name: "error-6",
                    component: () => import("@/view/pages/error/Error-6.vue"),
                },
            ],
        },
        {
            path: "/",
            component: () => import("@/view/pages/Custom/Auth/Auth"),
            children: [
                {
                    name: "login",
                    path: "/login",
                    component: () => import("@/view/pages/Custom/Auth/Login"),
                    meta: { requiresNotAuth: true },
                },
                {
                    name: "register",
                    path: "/register",
                    component: () => import("@/view/pages/Custom/Auth/Register"),
                    meta: { requiresNotAuth: true },
                },
                {
                    name: "resetpassword",
                    path: "/resetpassword",
                    component: () => import("@/view/pages/Custom/Auth/ResetPassword"),
                    meta: { requiresNotAuth: true },
                },
                {
                    name: "forgottenpassword",
                    path: "/forgottenpassword",
                    component: () => import("@/view/pages/Custom/Auth/ForgottenPassword"),
                    meta: { requiresNotAuth: true },
                },
                {
                    name: "privacy",
                    path: "/privacy",
                    component: () => import("@/view/pages/Custom/Auth/PrivacyPolicy"),
                },
            ],
        },
        {
            path: "*",
            redirect: "/404",
        },
        {
            // the 404 route, when none of the above matches
            path: "/404",
            name: "404",
            component: () => import("@/view/pages/error/Error-1.vue"),
        },
    ],
});
